export default "__VITE_ASSET__DL6UQR6Y__"